import { Backdrop, Box, Button, CircularProgress, Container, Divider, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { useSearchParams, useParams } from "react-router-dom";
import { CancelOutlined, CheckCircleOutline, ErrorOutlineOutlined } from "@mui/icons-material";
import { Context } from "../App";

export default function StatusPaiement() {
    const { setIsConnected } = React.useContext(Context);
    const [searchParams] = useSearchParams();
    const params = useParams();
    const checkoutId = searchParams.get('checkout_id') || searchParams.get('checkoutId') || params.checkoutId;
    const commandeId = searchParams.get('commande') || params.commande;
    const status = searchParams.get('status') || searchParams.get('paymentStatus');
    const [load, setLoad] = React.useState(true);
    const [commande, setCommande] = React.useState(null);
    // const [status, setStatus] = React.useState(null);
    const [viewMoreInfo, setViewInfo] = React.useState(false);

    useEffect(() => {
        if (checkoutId) {
            fetch(`${process.env.REACT_APP_API_URL}/commandes/status/${checkoutId}`, { method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
             })
            .then(response => {
                const token = response.headers.get('x-auth-token');
                if (token) localStorage.setItem('token', token);
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    setIsConnected(false);
                    setLoad(false);
                    throw new Error('Unauthorized');
                }
                return response.json()
            })
            .then(data => {
                if(!data) {
                    throw new Error("No data received from the server");
                }
                const paiement = data.payments.find(p=> p.txId===checkoutId);
                if (!paiement) {
                    throw new Error("Payment not found for the provided checkoutId");
                }
                setCommande(data)
            })
            .catch(error => {
                console.error('Error fetching payment status:', error);
            });    
        } 
        
        if (commandeId) {
            fetch(`${process.env.REACT_APP_API_URL}/commandes/${commandeId}`, { method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then(response => {
                const token = response.headers.get('x-auth-token');
                if (token) localStorage.setItem('token', token);
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    setIsConnected(false);
                    setLoad(false);
                    throw new Error('Unauthorized');
                }
                return response.json()
            })
            .then(data => {
                if(!data) {
                    throw new Error("No data received from the server");
                }
                setCommande(data);
                setLoad(false);
            })
            .catch(error => {
                console.error('Error fetching commande:', error);
                setLoad(false);
            });
        } else {
            console.error("No checkoutId or commandeId provided in the URL");
            setLoad(false);
        }
    }, [checkoutId, commandeId]);

    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Header />

            <Container maxWidth="lg" sx={{ flexGrow:1, mt: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', px: { xs: 2, sm: 3 } }}>
                {status==='success'?
                <Box sx={{ display: 'flex', flexDirection: 'column', width: { xs: '100%', sm: '80%', md: '60%' }, minWidth: { xs: 280, sm: 300 }, alignItems: 'center' }}>
                    <CheckCircleOutline color="validation" sx={{ fontSize: { xs: 80, sm: 100 }, alignSelf:'center' }}/>
                    <Typography variant="h1" fontWeight={500} color="validation" my={2} sx={{ textAlign: 'center' }}>Paiement validé</Typography>
                    <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>Votre paiement à bien été enregistré</Typography>
                    <Typography variant="body3" align="center" mb={4}>Vous recevrez un mail de confirmation contenant vos billets ainsi que votre reçu. Vous pouvez dors et déjà consulter et télécharger vos billets et reçus depuis l'espace <a href='/mes_billets'>Mes Billets</a>.</Typography>
                </Box>
                : status==='cancel'?
                <>
                    <CancelOutlined color="focus" sx={{ fontSize: { xs: 80, sm: 100 }, alignSelf:'center' }}/>
                    <Typography variant="h1" fontWeight={500} color="focus" mt={2} sx={{ textAlign: 'center' }}>Paiement annulé</Typography>
                    <Typography variant="body1" sx={{ textAlign: 'center' }}>Votre paiement a été annulé.</Typography>
                </>
                : !!status &&
                <>
                    <ErrorOutlineOutlined color="focus" sx={{ fontSize: { xs: 80, sm: 100 }, alignSelf:'center' }}/>
                    <Typography variant="h1" fontWeight={500} color="focus" mt={2} sx={{ textAlign: 'center' }}>Échec de la transaction</Typography>
                    <Typography variant="body1" sx={{ textAlign: 'center' }}>Votre paiement n'a pas été validé.</Typography>
                    
                    { viewMoreInfo ? <Box sx={{ display: 'flex', flexDirection: 'column', backgroundColor: 'rgba(255,255,255,0.4)', py: { xs: 2, sm: 3 }, px: { xs: 2, sm: 4 }, mt:2, maxWidth: '100%' }}>
                        <Typography variant="subtitle2" align='center'>Votre paiement n'a pas pu aboutir.<br/>
                            Cela peut être causé par différents paramètres de votre appareil ou de votre banque.
                        </Typography>
                        <Typography sx={{mt:1}}> ✅ Voici quelques conseils pour réussir votre paiement :</Typography>

                        <Box sx={{ml: { xs: 2, sm: 8 }, mt:1, display: 'flex', flexDirection: 'column'}}>
                            <Typography variant="subtitle3">Désactivez la navigation privée / incognito</Typography>
                            <Typography variant="body3">Certains navigateurs comme Safari ou Firefox peuvent bloquer les systèmes de sécurité en mode privé.</Typography>

                            <Typography variant="subtitle3" mt={1}>Essayez avec un autre navigateur (Google Chrome recommandé)</Typography>
                            <Typography variant="body3">Chrome offre une meilleure compatibilité avec les paiements en ligne sécurisés.</Typography>

                            <Typography variant="subtitle3" mt={1}>Vérifiez votre connexion internet</Typography>
                            <Typography variant="body3">Les connexions d'entreprise, d'école ou les VPN peuvent bloquer certains services nécessaires au paiement.</Typography>

                            <Typography variant="subtitle3" mt={1}>Désactivez temporairement votre antivirus ou pare-feu</Typography>
                            <Typography variant="body3">Ils peuvent empêcher le bon déroulement de la vérification de sécurité.</Typography>

                            <Typography variant="subtitle3" mt={1}>Utilisez un appareil plus récent si possible</Typography>
                            <Typography variant="body3">Certains anciens appareils ou navigateurs ne sont pas compatibles avec les systèmes d'authentification modernes (comme le 3D Secure).</Typography>

                            <Typography variant="subtitle3" mt={1}>Contactez votre banque</Typography>
                            <Typography variant="body3">L'émetteur de votre carte peut avoir bloqué la transaction pour des raisons de sécurité.</Typography>
                            <Typography variant="body3">Essayez :</Typography>

                            <Typography variant="body3">Une autre carte bancaire</Typography>

                            <Typography variant="body3">Ou un autre moyen de paiement si disponible</Typography>
                        </Box>

                        <Divider sx={{ alignSelf: 'center', width: { xs: '80%', sm: '50%' }, mt:4, mb: 2 }} />

                        <Typography variant="subtitle2" align="center">Besoin d'aide ?</Typography>
                        <Typography variant="body3" sx={{ mt: 1, textAlign: 'center' }}>
                            Si le problème persiste, n'hésitez pas à nous contacter pour obtenir de l'aide depuis la page <a href="/contact">Contact</a> ou par mail à <a href="mailto:contact@mygospelpass.com">contact@mygospelpass.com</a>.
                        </Typography> 
                    </Box>
                    :
                    <Button variant="text" color='focus2' onClick={()=>setViewInfo(true)}>En savoir plus</Button>
                    }
                </>}
                {commande &&
                <Box sx={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white', py: { xs: 3, sm: 4 }, px: { xs: 4, sm: 8 }, borderRadius: 2, my:2, maxWidth: '100%' }}>
                    <Typography variant="h6" textAlign='center'>Identifiants de la transaction</Typography>
                    <Typography variant="body1" sx={{ mt: 2 }}>N° de reçu : {commande?.recuNum || ' -- '}</Typography>
                    {commande && <Typography variant="body1">N° de commande : {commande.num}</Typography>}
                </Box>}
            </Container>
        
            <Footer />
            {/* <Backdrop open={load}><CircularProgress/></Backdrop> */}
        </Box>
    );
}